"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.confirmSubmitStockUp = confirmSubmitStockUp;
exports.createStockUp = createStockUp;
exports.deleteStockUp = deleteStockUp;
exports.getStockUpDetail = getStockUpDetail;
exports.getStockUpList = getStockUpList;
exports.getStockUpStatistics = getStockUpStatistics;
exports.printStockUp = printStockUp;
exports.shipStockUp = shipStockUp;
exports.stockUpStockUp = stockUpStockUp;
exports.updateStockUp = updateStockUp;

var _request = _interopRequireDefault(require("@/utils/request"));

/**
 * 备货列表查询（以t_send_stock_up为主表）
 */
function getStockUpList(params) {
  return (0, _request.default)({
    url: 'api/stock-up',
    method: 'get',
    params: params
  });
}
/**
 * 备货状态统计
 */


function getStockUpStatistics() {
  return (0, _request.default)({
    url: 'api/stock-up/statistics',
    method: 'get'
  });
}
/**
 * 备货详情
 */


function getStockUpDetail(id) {
  return (0, _request.default)({
    url: "api/stock-up/".concat(id),
    method: 'get'
  });
}
/**
 * 新增备货记录
 */


function createStockUp(data) {
  return (0, _request.default)({
    url: 'api/stock-up',
    method: 'post',
    data: data
  });
}
/**
 * 编辑备货记录
 */


function updateStockUp(data) {
  return (0, _request.default)({
    url: 'api/stock-up',
    method: 'put',
    data: data
  });
}
/**
 * 删除备货记录
 */


function deleteStockUp(id) {
  return (0, _request.default)({
    url: "api/stock-up/".concat(id),
    method: 'delete'
  });
}
/**
 * 确认发起 (status 0 → 1)
 */


function confirmSubmitStockUp(ids, deliveryTime) {
  return (0, _request.default)({
    url: 'api/stock-up/confirm-submit',
    method: 'put',
    data: {
      ids: ids,
      deliveryTime: deliveryTime
    }
  });
}
/**
 * 打单 (status 1 → 2)
 */


function printStockUp(ids, deliveryTime) {
  return (0, _request.default)({
    url: 'api/stock-up/print',
    method: 'put',
    data: {
      ids: ids,
      deliveryTime: deliveryTime
    }
  });
}
/**
 * 备货指令 (status 2 → 3)
 */


function stockUpStockUp(ids) {
  return (0, _request.default)({
    url: 'api/stock-up/stock-up',
    method: 'put',
    data: {
      ids: ids
    }
  });
}
/**
 * 出库 (status 3 → 4)
 */


function shipStockUp(ids) {
  return (0, _request.default)({
    url: 'api/stock-up/ship',
    method: 'put',
    data: {
      ids: ids
    }
  });
}